import JourneyLoader from './JourneyLoader';
import { JourneyLoaderProps } from './JourneyLoader.types';

export type { JourneyLoaderProps };
export default JourneyLoader;
